import React, { FC, useContext, useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';

import { GlobalContext } from '../../../../../store';
import { IAdminFlight } from '../../../../../store/admin/eventFlights/store';
import { IAdminEvent } from '../../../../../store/admin/events/store';
import { ITeam } from '../../../../../store/admin/eventTeams/store';
import { IEventEnrollment } from '../../../../../store/admin/eventEnrollments/store';

import { groupBy } from '../../../../../contrib/utils';
import { useTeamsCreatorDispatch } from '../../TeamsCreator/Context/TeamsCreator.context';
import FlightItem from './FlightItem/FlightItem';
import { TeamCard } from '../../../../../components/TeamCard/TeamCard';
import {
  IObjectById,
  getObjectByIdFromArray
} from '../../../../../contrib/Utils/getObjectByIdFromArray';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';

interface ITeamsByFlight {
  [teamId: string]: ITeam[];
  null: ITeam[];
}

export const TeamsFlights: FC = () => {
  const {
    actions: {
      adminEventTeams: { get: getAdminEventTeams }
    },
    adminEventTeams,
    adminEvents,
    adminEventEnrollments
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const [event, setEvent] = useState<IAdminEvent>();
  const [flights, setFlights] = useState<IAdminFlight[]>();
  const [teamsByFlight, setTeamsByFlight] = useState<ITeamsByFlight>({ null: [] });

  const { dispatch } = useTeamsCreatorDispatch();

  useEffect(() => {
    getAdminEventTeams(Number(clubId), Number(eventId));
  }, []);

  useEffect(() => {
    setEvent(adminEvents[Number(eventId)]);
  }, [adminEventTeams]);

  useEffect(() => {
    if (event) {
      setFlights(event.flights.filter(flight => flight.category === 't'));
    }
  }, [event]);

  useEffect(() => {
    if (adminEventTeams[Number(eventId)]) {
      setTeamsByFlight(groupBy(adminEventTeams[Number(eventId)], 'flight'));
    }
  }, [adminEventTeams, eventId]);

  useEffect(() => {
    if (eventId && adminEventEnrollments && adminEventEnrollments[Number(eventId)]) {
      const value: IObjectById<IEventEnrollment> = getObjectByIdFromArray<IEventEnrollment>(
        adminEventEnrollments[Number(eventId)]
      );

      dispatch({
        type: 'setEnrollments',
        value
      });
    }
  }, [adminEventEnrollments[Number(eventId)]]);

  return Object.keys(teamsByFlight).length > 0 ? (
    <>
      {teamsByFlight.null && teamsByFlight.null.length > 0 ? (
        <div className="unassigned-players-section">
          <h3>THESE TEAMS NEED A FLIGHT</h3>

          <Grid className="bottom" container={true} spacing={2} alignItems="center">
            {teamsByFlight.null.map(team =>
              team.isValid ? (
                <Grid
                  key={`team-card-teams-${team.id}`}
                  item={true}
                  className="gender-slot-container"
                  xs={12}
                  md={6}
                  lg={4}
                >
                  <TeamCard
                    context="teams"
                    team={team}
                    hideActions={true}
                    displayChangeTeamFlight={true}
                  />
                </Grid>
              ) : (
                <></>
              )
            )}
          </Grid>
        </div>
      ) : (
        <></>
      )}

      {flights &&
        flights.map(flight =>
          flight && !!teamsByFlight[flight.id] ? (
            <FlightItem
              type={'team'}
              key={`panel-flight-${flight.id}`}
              item={flight}
              enrollments={teamsByFlight[flight.id]}
            />
          ) : (
            <></>
          )
        )}
    </>
  ) : (
    <>
      <h3>THERE ARE NO TEAMS CREATED</h3>
    </>
  );
};
